import { LoadingView } from 'components';
import { SigningQuestionnaire } from 'modules/onboarding/common/components';
import { SigningDocumentsFormType } from 'modules/onboarding/common/forms/signingDocumentsForm';
import { useClientSigningQuestionnaire } from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from '../hooks/useOnboardingContext';

export const SigningQuestionnaireStep = () => {
  const { data, goToNext } = useOnboardingContext();

  const {
    onClickDocument,
    onSubmit,
    formError,
    loading,
    documents,
    submitLoading,
  } = useClientSigningQuestionnaire(data.ownerClient!);

  const handlerSubmit = async (values: SigningDocumentsFormType) => {
    if (values) {
      await onSubmit(values);
      goToNext();
    }
  };

  if (loading || !documents) {
    return <LoadingView />;
  }

  return (
    <SigningQuestionnaire
      documents={documents}
      formError={formError}
      submitLoading={submitLoading}
      onClickDocument={onClickDocument}
      onSubmit={handlerSubmit}
    />
  );
};
